import { z } from 'zod';

// Codice cassa: stringa libera (CE, EC, IT, ...). Il vincolo "appartiene a un
// territorio configurato" e' validato a runtime contro `config_casse`,
// non con un enum chiuso.
export const CassaCodeSchema = z.string().min(1).max(8);
export type CassaCode = string;

// Sesso
export const SessoSchema = z.enum(['M', 'F']).nullable();
export type Sesso = z.infer<typeof SessoSchema>;

// Stati lavoratore in posizione
export const StatoLavoratoreSchema = z.enum(['V', 'T', 'C', 'D']).nullable();
export type StatoLavoratore = z.infer<typeof StatoLavoratoreSchema>;

// Helper per campi nullable
export const str = z.string().nullable();
export const num = z.number().nullable();
export const dateStr = z.string().nullable(); // YYYY-MM-DD
export const periodoStr = z.string().nullable(); // YYYYMM
